import { combineReducers } from 'redux'

import { Reducer as Profile } from './modules/profile'
import { Reducer as User } from './modules/user'
import { Reducer as Professional } from './modules/professional'
import { Reducer as Coupon } from './modules/coupon'
import { Reducer as Customers } from './modules/customers'
import { Reducer as Module } from './modules/module'
import { Reducer as Notification } from './modules/notification'
import { Reducer as Modal } from './ui/modal'

export default () =>
  combineReducers({
    profile: Profile,
    user: User,
    professional: Professional,
    coupon: Coupon,
    customers: Customers,
    module: Module,
    notification: Notification,
    ui: combineReducers({
      modal: Modal
    })
  })
